export default "__VITE_ASSET__ZQxyuBZb__"